import { useAppSelector } from "lib/store";
import { getActiveNotificationsInLocation, hasSuccessInLocation } from "_slices/notifications";

type UseNotificationLocationReturn = [sendSuccess: any, activeNotifications: string[]];

export function useNotificationLocation(location: any): UseNotificationLocationReturn {

    let success = useAppSelector((state) => hasSuccessInLocation(location,state));
    let notifications = useAppSelector((state) => getActiveNotificationsInLocation(location,state));

    return [success,notifications]
}